<template>
    <CompassTooltip
        slot="reference"
        :content="itemText"
        placement="bottom"
        contentClass="navbar-tooltip"
        :arrow="false"
        :disabled="isDisableTooltip"
    >
        <a :href="itemUrl" class="navbar-content__actions--item-link" :class="itemClass">
            <CompassFlag
                v-if="isNew"
                label="New"
                size="small"
                class="navbar-content__actions--item-link-flag"
            />
            <i v-if="useFaIcon" class="fa navbar-content__actions--item-icon" :class="itemIcon" />
            <CompassIcon v-else :icon="itemIcon" class="navbar-content__actions--item-icon" />
            <span class="navbar-content__actions--item-label typographies-paragraph-small-regular">
                {{ itemText }}
            </span>
        </a>
    </CompassTooltip>
</template>

<script>
export default {
    props: {
        itemText: {
            type: String,
            required: true,
        },
        itemUrl: {
            type: String,
            required: true,
        },
        itemIcon: {
            type: String,
            required: true,
        },
        itemClass: {
            type: String,
            default: '',
        },
        useFaIcon: {
            type: Boolean,
            default: false,
        },
        isNew: {
            type: Boolean,
            default: false,
        },
        isDisableTooltip: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.navbar-content__actions--item-link {
    position: relative;

    &-flag {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        font-size: var(--font-size-10);
        line-height: var(--line-heights-12);
        padding: 0 var(--spacing-0);
    }
}
</style>
